import NewDirectoryForm, { useNewDirectoryFormData } from 'components/NewDirectoryForm';
import React, { useEffect, useState } from 'react';
import { formatType, getPath } from 'utils/entity.utils';

import { Dialog } from '@acheloisbiosoftware/absui.core';
import { ENTITY_DIRECTORY } from 'constants/schemas';
import PropTypes from 'prop-types';
import { directoryActions } from 'store/entity';
import { getGenericId } from 'utils/generic.utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function NewDirectoryDialog(props) {
  const { open, onClose, initState } = props;
  const {
    formData,
    valid,
    resetFormData,
    updateFormData,
  } = useNewDirectoryFormData(initState);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) resetFormData();
  }, [open, resetFormData]);

  const _onClose = () => {
    resetFormData();
    onClose();
  };

  const onConfirm = () => {
    setLoading(true);
    dispatch(directoryActions.createDirectory(formData))
      .unwrap()
      .then((res) => {
        _onClose();
        navigate(getPath(getGenericId(res.result, ENTITY_DIRECTORY)));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog
      title={`New ${formatType(ENTITY_DIRECTORY, { template: formData?.is_template })}`}
      open={open}
      onClose={_onClose}
      confirmButtonText='Create'
      disableCloseOnConfirm
      confirmDisabled={!valid}
      onConfirm={onConfirm}
      loading={loading}
      fullWidth
      maxWidth='xs'
    >
      <NewDirectoryForm
        formData={formData}
        updateFormData={updateFormData}
      />
    </Dialog>
  );
}

NewDirectoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  initState: PropTypes.object,
};

export default NewDirectoryDialog;
